// @ts-ignore
const winreg = () => window.nodeModules?.winreg as typeof import('winreg');

export default winreg;
